import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronDownIcon, CheckIcon } from '@heroicons/react/20/solid';

const CustomDropdown = ({ 
  value, 
  onChange, 
  options, 
  placeholder = "Select option...",
  className = "",
  disabled = false,
  renderOption = null,
  renderSelected = null
}) => {
  const selectedOption = options.find(option => option.value === value);

  return (
    <div className={`relative z-50 ${className}`}>
      <Listbox value={value} onChange={onChange} disabled={disabled}>
        <div className="relative">
          <Listbox.Button className="glass-input cursor-pointer w-full text-left pl-4 pr-12 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-indigo-400/50">
            <span className="block truncate">
              {renderSelected && selectedOption ? 
                renderSelected(selectedOption) : 
                (selectedOption?.label || placeholder)
              }
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
              <ChevronDownIcon
                className="h-4 w-4 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Listbox.Options 
              className="absolute mt-1 w-full overflow-visible rounded-lg bg-gray-800 border border-gray-600 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
              style={{ zIndex: 9999 }}
            >
              {options.map((option) => (
                <Listbox.Option
                  key={option.value}
                  className={({ active }) =>
                    `relative cursor-pointer select-none py-2 pl-10 pr-4 transition-colors duration-150 ${
                      active ? 'bg-indigo-600 text-white' : 'text-gray-200 hover:bg-gray-700'
                    }`
                  }
                  value={option.value}
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                        {renderOption ? renderOption(option) : option.label}
                      </span>
                      {selected ? (
                        <span
                          className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                            active ? 'text-white' : 'text-indigo-400'
                          }`}
                        >
                          <CheckIcon className="h-4 w-4" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default CustomDropdown;